/**
 * Strips the chrome that `styles/tailwind.css` applies to every `<button>` — border, shadow,
 * background, padding, margin and a fixed h-9 — so a button that should read as a hyperlink does.
 *
 * Pair it with the link colours, e.g.
 * `className={`text-link-page hover:text-link-page-hover underline ${LINK_BUTTON}`}`.
 *
 * A real link still deserves an `<a>`; this is for actions that happen in place and have no href.
 */
export const LINK_BUTTON = "border-0 shadow-none bg-transparent p-0 m-0 h-auto";
